export const Posts = {
  text: 'Posts',
  link: '/posts',
  icon: 'icon-speech'
};

export const Treinamentos = {
  text: 'Treinamentos',
  link: '/treinamentos',
  icon: 'icon-graduation'
};

export const Banners = {
  text: 'Banners',
  link: '/banners',
  icon: 'icon-picture'
};

export const Inconsistencias = {
  text: 'Inconsistências',
  icon: 'icon-wrench',
  submenu: [
    {
      text: 'Resumo',
      link: '/inconsistencias/resumo'
    }
  ]
};

export const Sonar = {
  text: 'Sonar',
      icon: 'icon-feed',
    submenu: [
  {
    text: 'Dashboard',
    link: '/dashboard/sonar'
  },
  {
    text: 'Logins',
    link: '/sonar/logins'
  },
  {
    text: 'Liberação de Resgates',
    link: '/sonar/resgates'
  }
]
}

// MENU USUARIOS //

export const menu = [
  {
    text: 'Dashboard',
    icon: 'icon-chart',
    submenu: [
      {
        text: 'Vendas',
        link: '/dashboard/vendas'
      },
      {
        text: 'Cadastros',
        link: '/dashboard/cadastros'
      },
      {
        text: 'Qualidade',
        link: '/dashboard/qualidade'
      }
    ]
  },
  {
    text: 'Rankings',
    icon: 'icon-badge',
    submenu: [
      {
        text: 'Lojas',
        link: '/ranking/lojas'
      },
      {
        text: 'Redes',
        link: '/ranking/redes'
      },
      {
        text: 'DDDs',
        link: '/ranking/ddds'
      },
      {
        text: 'CNs',
        link: '/ranking/cns'
      },
      {
        text: 'Vendedores',
        link: '/ranking/vendedores'
      }
    ]
  },
  {
    text: 'Usuários',
    link: '/usuarios',
    icon: 'icon-people'
  },
  {
    text: 'Ativações',
    link: '/ativacoes',
    icon: 'icon-screen-smartphone'
  },
  {
    text: 'Carteira do CN',
    icon: 'icon-wallet',
    submenu: [
      {
        text: 'Dashboard',
        link: '/carteira-cn/dashboard'
      },
      {
        text: 'Ações',
        link: '/carteira-cn/acoes'
      },
      {
        text: 'Extrato',
        link: '/carteira-cn/extrato'
      },
      {
        text: 'PIX',
        link: '/carteira-cn/transferencia'
      }
    ]
  }
];

export const menuRedes = [
  {
    text: 'Dashboard',
    link: '/dashboard/redes',
    icon: 'icon-chart'
  },
  {
    text: 'Usuários',
    link: '/usuarios',
    icon: 'icon-people'
  },
  {
    text: 'Ativações',
    link: '/ativacoes',
    icon: 'icon-screen-smartphone'
  }
];

export const menuIcons = [
  /* {
    text: 'Dashboard',
    icon: 'icon-chart',
    submenu: [
      {
        text: 'Resultados',
        link: '/dashboard/resultados'
      },
      {
        text: 'Carteira',
        link: '/dashboard/carteira'
      },
      {
        text: 'Vendas',
        link: '/dashboard/vendas'
      },
      {
        text: 'Cadastros',
        link: '/dashboard/cadastros'
      },
      {
        text: 'Pontos',
        link: '/dashboard/pontos'
      },
      {
        text: 'Cancelamentos',
        link: '/dashboard/cancelamentos'
      },
      {
        text: 'Qualidade',
        link: '/dashboard/qualidade'
      }
    ]
  },
  */
  Sonar,
  /*
  {
    text: 'Rankings',
    icon: 'icon-badge',
    submenu: [
      {
        text: 'Lojas',
        link: '/ranking/lojas'
      },
      {
        text: 'Redes',
        link: '/ranking/redes'
      },
      {
        text: 'DDDs',
        link: '/ranking/ddds'
      },
      {
        text: 'CNs',
        link: '/ranking/cns'
      },
      {
        text: 'Vendedores',
        link: '/ranking/vendedores'
      }
    ]
  },
   */
  {
    text: 'Usuários',
    icon: 'icon-people',
    submenu: [
      {
        text: 'Novo Usuário',
        link: '/usuarios/novo'
      },
      {
        text: 'Todos os Usuários',
        link: '/usuarios'
      }
    ]
  },
  /*
  {
    text: 'PDVs',
    icon: 'icon-home',
    submenu: [
      {
        text: 'Novo PDV',
        link: '/pdvs/novo'
      },
      {
        text: 'Todos os PDVs',
        link: '/pdvs'
      }
    ]
  },
  {
    text: 'Ativações',
    link: '/ativacoes',
    icon: 'icon-screen-smartphone'
  },
  {
    text: 'Carteira do CN',
    icon: 'icon-wallet',
    submenu: [
      {
        text: 'Dashboard',
        link: '/carteira-cn/dashboard'
      },
      {
        text: 'Ações',
        link: '/carteira-cn/acoes'
      },
      {
        text: 'Extrato',
        link: '/carteira-cn/extrato'
      },
      {
        text: 'PIX',
        link: '/carteira-cn/transferencia'
      }
    ]
  }
  */
  Posts,
  Banners,
  {
    text: 'Chamados',
    icon: 'icon-bubbles',
    submenu:[
      {
        text: 'Chamados',
        link: '/chamados',
      },
      // {
      //   text: 'Nível Satisfação',
      //   link: '/chamados/dashboard'
      // },
    ]
  },
  {
    text: 'CloudLoyalty',
    icon: 'icon-basket',
    submenu: [
      {
        text: 'Usuários',
        link: '/cloudloyalty/usuarios'
      },
      {
        text: 'Resgates',
        link: '/cloudloyalty/resgates'
      }
    ]
  },
  /*
  {
    text: 'Apuração',
    icon: 'icon-calculator',
    submenu: [
      {
        text: 'Importar',
        link: '/apuracao/importar'
      },
      {
        text: 'Liberar',
        link: '/apuracao/liberar'
      }
    ]
  },*/
  {
    text: 'Push Notification',
    icon: 'icon-bell',
    submenu: [
      {
        text: 'Push',
        link: '/push-notification'
      }
    ]
  }
   
];
